<template>
  <BaseModal
    ref="modal"
    modal-classes="max-w-md mx-auto mt-16"
    @modal-after-leave="$emit('closed')"
  >
    <template #header>
      <h3 class="text-2xl text-gray-900">Add existing pipeline</h3>
    </template>

    <template>
      <div class="flex flex-col">
        <div class="flex-none">
          <label class="block font-medium uppercase text-sm text-muted mb-2">Search</label>
          <input
            type="text"
            class="input"
            :disabled="pending"
            @change="searchPipeline($event.target.value)"
          />
        </div>

        <div class="flex-1 mt-8">
          <label class="block font-medium uppercase text-sm text-muted mb-2">Results</label>
          <div class="-mx-4">
            <ul class="overflow-auto max-h-72 px-2">
              <li v-if="pending">
                <div class="text-center">
                  <Loader />
                </div>
              </li>
              <template v-else>
                <li
                  v-for="pipeline in pipelines"
                  :key="pipeline.id"
                  class="hover:bg-smoke-100 rounded px-4 py-2 cursor-default select-none"
                  @click="linkPipeline(pipeline)"
                >
                  {{ pipeline.name }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    accountUuid: { type: String, required: true },
    projectUuid: { type: String, required: true },
  },

  data() {
    return {
      pending: false,
    };
  },

  computed: {
    ...mapGetters('ui/accountPipelines', ['pipelines']),
  },

  created() {
    this.searchPipeline('');
  },

  methods: {
    ...mapActions('ui/projectPipelines', {
      storePipeline: 'store',
    }),
    ...mapActions('ui/accountPipelines', {
      loadPipelines: 'load',
    }),
    async searchPipeline(search) {
      this.pending = true;

      const { accountUuid: accountId = null } = this;

      if (!accountId) return;

      try {
        await this.loadPipelines({ accountId, params: { filter: { search } } });
      } catch (error) {
        //
      }

      this.pending = false;
    },
    linkPipeline(pipeline) {
      this.submitAction({ pipeline_id: pipeline.id });
    },
    async submitAction(formData) {
      const { projectUuid } = this;

      this.pending = true;

      try {
        await this.storePipeline({ projectUuid, formData });

        this.$refs.modal.doClose();
      } catch (error) {
        //
      }

      this.pending = false;
    },
  },
};
</script>
